<template lang="html">
	<div ref="popupContainer" class="centerx">
		<vs-popup :active.sync="showValidationPopup" title="Êtes-vous sûr de vouloir supprimer ce contact ?"  style="z-index: 99999">
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="acceptDeletion()">Oui</vs-button>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="declineDeletion()">Non</vs-button>
				</div>
			</div>
		</vs-popup>
		<vs-popup :active.sync="isPopupActive" class="mw-1/2" :title="!societyToModify.edit ? society.name : ''" style="z-index: 53001;" :key="refreshEdit">
			<div class="container" >
					<div class="vx-col mb-base w-full" >
						<div v-if="activeUser.role != '2' && activeUser.type != '7'" class="vx-row w-full ml-2 flex" style="justify-content: space-between;">
							<div class="vx-col left-elem">
								<vs-button v-if="!societyToModify.edit" @click="onClickUpdate()">
									Modifier Client
								</vs-button>
								<vs-button v-else @click="updateSociety(false)">
									Verrouiller
								</vs-button>
							</div>
							<div class="vx-col" v-if="!societyToModify.edit">
								<vx-tooltip :text="colorQB == 'orange' ? 'En cours de vérification Pennylane' : colorQB == 'red' ? 'Lien Pennylane introuvable' : 'Lien Pennylane trouvé, ID : ' + idQB" style="display: inline-block;">
									<vs-icon
										icon="bolt"
										size="medium"
										color="white"
										:style="'background-color: ' + colorQB + '; border-radius: 30px;'"
									></vs-icon>
								</vx-tooltip>
							</div>
							<div v-if="societyToModify.edit && $acl.check('sadmin')" class="vx-col mt-2 center-align f-color" style="white-space: nowrap;">
								<vs-select
									autocomplete
									v-model="idQB"
									class="w-full select-medium"
									@change="updateSocietyQuickbooksCustomer()"
								>
									<vs-select-item
										:value="0"
										:text="'Pennylane Customer ID'"
										class="w-full"
									/>
									<vs-select-item
										:key="index"
										:value="item.source_id"
										:text="item.source_id + ': ' + item.name"
										v-for="(item, index) in listCustomersQB"
										class="w-full"
									/>
								</vs-select>
							</div>
						</div>
						<div class="vx-row w-full center ml-1">
							<span v-if="!societyToModify.edit">
								<img :src="societyImage" style="max-width: 264px; max-height: 150px;"/>
								<!-- <vs-icon icon="business" size="75px" color="black"></vs-icon> -->
							</span>
							<div v-else class="vx-col sm:w-1/4 w-full mt-6 mb-6">
								<vs-card style="min-width: 300px; max-width: 350px;">
									<div slot="header">
										<p class = "mb-2">Sélectionnez une image</p>
										<input type="file" name="file" accept="image/*" @change="addImagePreview($event)">
									</div>
									<div class="vx-col w-full mt-6 mb-6 text-center" v-if="image" >
									<img v-if ="!isImageModifyOn" :src="image" style="max-width: 264px;max-height: 150px;"/>
										<vue-cropper v-else
											ref="cropper"
											:src="image"
											preview=".preview"
											:cropBoxResizable="false"
											:cropBoxMovable="false"
											:minCropBoxWidth="264"
											:minCropBoxHeight="150"
											dragMode="move"
										/>
									</div>
										<vs-row  v-if="image" style="justify-content: space-around;display: flex;">
										<div>
											<vs-button
												color="success"
												@click="$refs.cropper.relativeZoom(0.1);"
											>+</vs-button>
											<vs-button
												color="danger"
												@click="$refs.cropper.relativeZoom(-0.1);"
											>-</vs-button>
											</div>
											<div >
												<vs-button v-if="isImageModifyOn" @click="updateSociety(true)">Enregistrer</vs-button>
												<vs-button v-else @click="isImageModifyOn = true">Modifier</vs-button>
												</div>
										</vs-row>
								</vs-card>
							</div>
						</div>
						<!-- <div class="vx-row center ml-1">
							<div class="vx-col title f-color">
							{{ society.name.toUpperCase() }}
							</div>
						</div> -->
						<div v-if="societyToModify.edit" class="vx-row w-full center ml-1">
							<vs-input class="inputx" placeholder="Nom de la société" v-model="societyToModify.name"/>
						</div>
						<div class="vx-row w-full center ml-1">
							<div v-if="!societyToModify.edit" class="vx-col mt-2 center-align f-color">
								Siret : {{ society.siret || " " }}
							</div>
							<div v-else class="vx-col mt-2 center-align f-color">
								Siret : <vs-input class="inputx" v-model="societyToModify.siret"/>
							</div>

							<div v-if="!societyToModify.edit" class="vx-col mt-2 center-align f-color">
								Type : {{ getSocietyType(society.is_ecommerce) || " " }}
							</div>
							<div v-else class="vx-col mt-2 center-align f-color" style="white-space: nowrap;">
								Type :
								<vs-select
									autocomplete
									v-model="societyToModify.is_ecommerce"
									class="w-full select-medium"
								>
									<vs-select-item
										:key="index"
										:value="item.value"
										:text="item.text"
										v-for="(item, index) in ecommerceOptions"
										class="w-full"
									/>
								</vs-select>
							</div>

							<div v-if="!societyToModify.edit" class="vx-col mt-2 center-align f-color">
								<vs-chip
									style="width: 80px"
									:color="getContractStatusColor(society.status)">{{
									getStatus(society.status)
								}}</vs-chip>
							</div>
							<div v-else class="vx-col mt-2 center-align f-color">
								<vx-input-group class="w-full center ">
									<vs-switch v-model="societyToModify.status">
										<span slot="on">Statut Actif</span>
										<span slot="off">Statut Inactif</span>
									</vs-switch>
								</vx-input-group>
							</div>

							<div class="vx-col mt-2 center-align f-color" v-if="societyContracts.length > 0">
								<span
									v-for="contract in societyContracts"
									:key="contract.id"
									@click="displayContractPopup(contract)"
								>
									<vs-chip
										:color="getContractStatusColor(contract.status)"
										style="cursor: pointer;"
										>{{ contract.id }} - {{ getProductCategoryName(contract.delivery) }}
									</vs-chip>
								</span>
							</div>
							<div class="vx-row w-full mt-2 center-align f-color flex" style="flex-direction: column;">
								Domaine d'activité :
								<div v-if="!societyToModify.edit">
									<vs-chip
										v-for="(tag, indextag) in listDomain"
										color="gray"
										:key="indextag"
									>
										{{tag.name}}
									</vs-chip>
								</div>
								<div v-else class="vx-col w-full" style="margin-top: 1px; min-width: 50px; margin-bottom: 5px;">
									<vx-input-group class="inlineB bottom">
										<vue-tags
											class="w-full"
											placeholder="Domaine d'activité"
											:active="societyToModify.activity_domain"
											:all="listAllDomains"
											:tag-creation-enabled="true"
											tag-list-label=""
											@on-tag-added="onTagAdded($event)"
											@on-tag-removed="onTagRemoved($event)"
											@on-tag-created="onTagAdded($event)"
											@on-tag-list-opened="tagStyle = 'z-index: 1 !important; overflow: visible;'"
											@on-tag-list-closed="tagStyle = 'z-index: 1 !important; overflow: auto;'"
											:style="tagStyle"
										>
										</vue-tags>
									</vx-input-group>
								</div>
							</div>
						</div>
					<div class="vx-row w-full ml-1 t-border">
						<div class="vx-col w-1/2 mt-2">
							Date de création:
							<span class="f-color">{{
								getDateToFrenchFormat(society.creation_timestamp)
							}}</span>
						</div>
						<div class="vx-col w-1/2 mt-2">
							Commercial:
							<span v-if="!societyToModify.edit" class="f-color">{{ commercialSocietyName }}</span>
							<div v-else style="display: inline-block;">
								<vs-select
									v-model="societyToModify.commercial_id"
									class="w-full select-medium mr-2"
									autocomplete
								>
									<vs-select-item
										:key="index"
										:value="item.id"
										:text="item.firstname + ' ' + item.lastname"
										v-for="(item, index) in commercials"
										class="w-full"
									/>
								</vs-select>
							</div>
						</div>
					</div>
					<div class="vx-row w-full center ml-1 mt-2">
						<div class="vx-col w-1/2 mt-2">
							Dernière Mise à Jour:
							<span class="f-color">{{
								getDateToFrenchFormat(society.last_update_timestamp)
							}}</span>
						</div>
						<div class="vx-col w-1/2 mt-2">
							Origine :
							<span v-if="!societyToModify.edit" class="f-color ml-1">{{ getSocietyOrigin(society.origin) }}</span>
							<div v-else style="display: inline-block;">
								<vs-select
									autocomplete
									v-model="societyToModify.origin"
									class="w-full select-medium mr-2"
								>
									<vs-select-item
										:key="index"
										:value="item.value"
										:text="item.text"
										v-for="(item, index) in originOptions"
										class="w-full"
									/>
								</vs-select>
							</div>
						</div>
					</div>
											<!-- Buttons Section -->
					<div class="m-5 flex justify-center">
							
							<vs-button color="primary" class="mr-2" @click="onClickTopKeywordsPopup()">Top Keywords</vs-button>
							<vs-button color="warning" class="mr-2" @click="onClickCompetitors()">Concurrents</vs-button>
							<vs-button color="danger" @click="onClickBrands()">Marque</vs-button>
						</div>
					<div class="vx-row w-full ml-1 mt-2 t-border">
						<div class="vx-col mt-2" style="margin-bottom: 10px;">
							
							<div class="w-full">Coordonnées:</div>
							<div v-if="!societyToModify.edit" class="w-full mt-2 center-align f-color">
								<vs-icon
								class="mr-2"
								icon="room"
								size="medium"
								color="black"
								></vs-icon>
								{{ completeAdress }}
							</div>
							<div v-else class="w-full mt-2 center-align f-color">
								<vs-icon
									class="mr-2"
									icon="room"
									size="medium"
									color="black"
								></vs-icon>
								<vs-input class="inputx" placeholder="Adresse" v-model="societyToModify.adress"/>
								<vs-input class="inputx ml-2" placeholder="Complément d'adresse" v-model="societyToModify.adress_complement"/>
								<vs-input class="inputx ml-2" placeholder="Code Postale" v-model="societyToModify.postal_code" @input="societyToModify.postal_code = societyToModify.postal_code.replace(/[^\d]/g, '').substr(0, 11)"/>
								<vs-input class="inputx ml-2" placeholder="Ville" v-model="societyToModify.city"/>
								<vs-select
									autocomplete
									v-model="societyToModify.country_id"
									class="select-medium"
									@change="validateTVARequired()"
								>
									<vs-select-item
										:key="index"
										:value="item.id"
										:text="item.fr_fr_name"
										v-for="(item, index) in countries"
										class="w-full"
									/>
								</vs-select>
							</div>
									<!-- Language -->
									<div class="mt-3">
							<div v-if="!societyToModify.edit" class="w-full center-align f-color">
								<vs-icon
									class="mr-2"
									icon="language"
									size="medium"
									color="black"
								></vs-icon>
								{{ getLanguageName(society.language_id) || " " }}
							</div>
							<div v-else class="w-1/5 center-align f-color">
								<vs-icon
									class="mr-2"
									icon="language"
									size="medium"
									color="black"
								></vs-icon>
								<vs-select
								autocomplete
								v-model="societyToModify.language_id"
								placeholder="Langue de la facture"
								class="w-full select-medium"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in languages"
									class="w-full"
								/>
							</vs-select>
							</div>
							</div>
							<!-- Language -->
							<!-- Currency -->
							<div class="mt-3">
							<div v-if="!societyToModify.edit" class="w-full center-align f-color">
								<vs-icon
									class="mr-2"
									icon="money"
									size="medium"
									color="black"
								></vs-icon>
								{{ getCurrenciesName(society.currency_id) || " " }}
							</div>
							<div v-else class="w-1/5 center-align f-color">
								<vs-icon
									class="mr-2"
									icon="money"
									size="medium"
									color="black"
								></vs-icon>
								<vs-select
								autocomplete
								v-model="societyToModify.currency_id"
								placeholder="Devise de la facture"
								class="w-full select-medium"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in currencies"
									class="w-full"
								/>
							</vs-select>
							</div>
							</div>
							<!-- Currency -->
							<!-- Phone -->
							<div class="mt-3">
							<div v-if="!societyToModify.edit" class="w-full center-align f-color">
								<vs-icon
									class="mr-2"
									icon="phone"
									size="medium"
									color="black"
								></vs-icon>
								{{ society.phone }}
							</div>
							<div v-else class="w-full center-align f-color">
								<vs-icon
									class="mr-2"
									icon="phone"
									size="medium"
									color="black"
								></vs-icon>
								<vs-input class="inputx" placeholder="Téléphone" v-model="societyToModify.phone" @input="societyToModify.phone = societyToModify.phone.replace(/[^\d\s]/g, '')"/>
							</div>
							</div>
						<!-- Phone -->
						<!-- Siret -->
						<div class="mt-3">
							<div v-if="!societyToModify.edit" class="w-full center-align f-color">
								<vs-icon
									class="mr-2"
									icon="gavel"
									size="medium"
									color="black"
								></vs-icon>
								{{ society.tva || " " }}
							</div>
							<div v-else class="w-full center-align f-color">
								<vs-icon
									class="mr-2"
									icon="gavel"
									size="medium"
									color="black"
								></vs-icon>
								<vs-input class="inputx ml-2" placeholder="TVA" v-model="societyToModify.tva"/>
								<vs-select
									autocomplete
									v-model="societyToModify.tva_id"
									class="select-medium ml-2"
								>
									<vs-select-item
										:key="index"
										:value="item.id"
										:text="item.name"
										v-for="(item, index) in tva_ids"
										class="w-full"
									/>
								</vs-select>
								<vs-select
									autocomplete
									v-model="societyToModify.term_id"
									class="select-medium ml-2"
								>
									<vs-select-item
										:key="index"
										:value="item.id"
										:text="item.name"
										v-for="(item, index) in termsOptions"
										class="w-full"
									/>
								</vs-select>
							</div>
						</div>
						<!-- Siret -->
						<!-- Website -->
						<div class="mt-3">

							<div v-if="!societyToModify.edit" class="w-full center-align f-color">
								<vs-icon
									class="mr-2"
									icon="language"
									size="medium"
									color="black"
								></vs-icon>
								<a :href="society.website" target="_blank" class="hvr-underline hvr-underline-out">{{ society.website || " " }}</a>
							</div>
							<div v-else class="w-full center-align f-color">
								<vs-icon
									
									class="mr-2"
									icon="language"
									size="medium"
									color="black"
								></vs-icon>
								<vs-input label ="Url du site" class="inputx" placeholder="Site web" v-model="societyToModify.website" @blur="validateWebsite()"/>
							</div>
						</div>
						<!-- Website -->
						</div>
					
						
						
					</div>

					<div class="vx-row center_div t-border w-full ml-1">
						<div class="vx-col mt-2" style="margin-bottom: 10px;">
						<!-- SEARCH CONSOLE -->

						<div class="mt-3">

							<div v-if="societyToModify.edit" class="w-full center-align f-color">
								<vs-icon
									class="mr-2"
									icon="show_chart"
									size="medium"
									color="black"
								></vs-icon>
								<vs-input
									label ="Url (search console)"
									class="inputx"
									placeholder="Url (search console)"
									v-model="societyToModify.gsc_url"
									@blur="validateGSCUrl()"
								/>
							</div>
							<div v-else class="w-full center-align f-color">
								<vs-icon
									class="mr-2"
									icon="show_chart"
									size="medium"
									color="black"
								></vs-icon>
								<a :href="society.gsc_url" target="_blank" class="hvr-underline hvr-underline-out">{{ society.gsc_url || " " }}</a>
							</div>
						</div>

							<!-- /SEARCH CONSOLE -->
							<!-- ANALYTICS -->

						<div class="mt-3">
							<div v-if="societyToModify.edit" class="w-full center-align f-color">
								<vs-icon
									class="mr-2"
									icon="bar_chart"
									size="medium"
									color="black"
								></vs-icon>
								<vs-input
									label ="View Id (analytics)"
									class="inputx"
									placeholder="View Id (analytics)"
									v-model="societyToModify.analytics_id"
									@input="societyToModify.analytics_id = societyToModify.analytics_id.replace(/[^\d]/g, '')"
								/>
							</div>
							</div>
							<div class="mt-3">
							<div v-if="societyToModify.edit" class="w-full center-align f-color">
								<vs-icon
									class="mr-2"
									icon="bar_chart"
									size="medium"
									color="black"
								></vs-icon>
								<vs-input
									label ="MCC Id (Google Ads)"
									class="inputx"
									placeholder="MCC Id (Google Ads)"
									v-model="societyToModify.google_ads_mcc"
									@input="societyToModify.google_ads_mcc = societyToModify.google_ads_mcc.replace(/[^\d]/g, '')"
								/>
							</div>
							</div>
							<!-- Export to BigQuery -->
							<div class="mt-3">
								<div class="w-full center-align f-color">
									<vs-icon
										class="mr-2"
										icon="cloud_upload"
										size="medium"
										color="black"
									></vs-icon>
									<div>
									<label v-if ="societyToModify.edit" style="font-size: .85rem; color: rgba(0, 0, 0, .7);">Exporter vers BigQuery</label>
									<vx-input-group class="center" label="Exporter vers BigQuery">
										<vs-switch
											v-model="societyToModify.export_to_big_query"
											:disabled="!societyToModify.edit"
										>
											<span slot="on"></span>
											<span slot="off"></span>
										</vs-switch>
									</vx-input-group>
									</div>
								</div>
							</div>
							</div>
							<!-- /Export to BigQuery -->
						</div>
					<div class="vx-row center_div t-border w-full ml-1">
						<vs-table :data="relatedUser" v-if="relatedUser" class="w-full">
							<template slot="thead">
								<vs-th>Civilité</vs-th> <!-- Madame ou Monsieur -->
								<vs-th>Prénom</vs-th> <!-- Prénom -->
								<vs-th>Nom</vs-th> <!-- Nom -->
								<vs-th>Type de contact</vs-th> <!-- Commercial ou Facturation -->
								<vs-th>Fonction du contact</vs-th> <!-- PDG, Directeur marketing  -->
								<vs-th>Email</vs-th> <!-- Email -->
								<vs-th>Téléphone</vs-th> <!-- Téléphone -->
								<vs-th>Accès Dashboard</vs-th>
								<vs-th v-if="activeUser.role != '2' && activeUser.type != '7'"></vs-th>
								<vs-th v-if="activeUser.role != '2' && activeUser.type != '7'"></vs-th>
							</template>

							<template slot-scope={data}>
	<vs-tr :key="indextr" v-for="(tr, indextr) in data">
		<vs-td>{{ getUserCivility(data[indextr].civility) }}</vs-td>
		<!-- Madame ou Monsieur -->
		<vs-td>{{ data[indextr].firstname }}</vs-td>
		<!-- Prénom -->
		<vs-td>{{ data[indextr].lastname }}</vs-td>
		<!-- Nom -->
		<vs-td>{{ getUserTitle(data[indextr].type) }}</vs-td>
		<!-- Commercial ou Facturation -->
		<vs-td>{{ getFonction(data[indextr].fonction) }}</vs-td>
		<!-- PDG, Directeur marketing -->
		<vs-td>{{ data[indextr].email }}</vs-td>
		<!-- Email -->
		<vs-td>{{ data[indextr].phone }}</vs-td>
		<!-- Téléphone -->
		<vs-td style="text-align: center">{{
			getUserDashboardAccess(data[indextr].hasAccess)
		}}</vs-td>
		<!-- hasAccess to Dashboard -->
		<vs-td v-if="activeUser.role != '2' && activeUser.type != '7'"
			><vs-button @click="modifyContact(data[indextr].id)"
				>Modifier</vs-button
			></vs-td
		>
		<vs-td v-if="activeUser.role != '2' && activeUser.type != '7'"
			><vs-button @click="displayValidationPopup(data[indextr].id)"
				>Désassocier</vs-button
			></vs-td
		>
	</vs-tr>
</template>
						</vs-table>
					</div>
					<div class="vx-row center_div t-border" v-if="activeUser.role != '2' && activeUser.type != '7'">
						<vs-button class="mt-2" @click="newContact(societyId)">Nouveau</vs-button>
					</div>
				</div>
			</div>
		</vs-popup>
	</div>
</template>

<script>
import Vue from "vue";
import store from "@/store/store";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import Society from "@/entities/Society";
import Product from "@/entities/Product";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { Collaborator } from "@/entities/Collaborator";
import { VueTags } from "vue-tags-component";
import VueCookies from "vue-cookies";
import TopKeywordEditorPopup from "./TopKeywordEditorPopup.vue";
import SocietyCompetitorsPopup from "./SocietyCompetitorsPopup.vue";
import SocietyBrandsPopup from "./SocietyBrandsPopup.vue";
export default {
	name: "SocietyInfoPopup",
	components: {
		VueTags,
		VueCropper,
	},
	props: {
		society: Object,
		popupActive: Boolean,
		router: Object,
		apiUrl: String,
		allowEdit: {
			type: Boolean,
			default: true,
		},
	},
	mixins: [dbFieldConvertor, utilsMixin],
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		completeAdress: function () {
			let adresse = "";
			if (
				this.$props.society.adress !== null &&
				this.$props.society.adress !== 0 &&
				this.$props.society.adress !== "0"
			)
				adresse += this.$props.society.adress + " ";
			if (
				this.$props.society.adress_complement !== null &&
				this.$props.society.adress_complement !== 0 &&
				this.$props.society.adress_complement !== "0"
			)
				adresse += this.$props.society.adress_complement + " ";
			if (
				this.$props.society.postal_code !== null &&
				this.$props.society.postal_code !== 0 &&
				this.$props.society.postal_code !== "0"
			)
				adresse += this.$props.society.postal_code + " ";
			if (
				this.$props.society.city !== null &&
				this.$props.society.city !== 0 &&
				this.$props.society.city !== "0"
			)
				adresse += this.$props.society.city + " ";
			if (
				this.$props.society.country !== null &&
				this.$props.society.country !== 0 &&
				this.$props.society.country !== "0"
			)
				adresse += this.$props.society.country;
			adresse = adresse.trim();
			return adresse;
		},
		countries: function () {
			return store.state.countries.sort((a, b) => {
				return a.fr_fr_name.localeCompare(b.fr_fr_name);
			});
		},
		listCustomersQB: function () {
			return store.state.customers;
		},
		societyId: function () {
			return this.$props.society.id;
		},
		termsOptions: function () {
			return store.state.terms;
		},
		tva_ids: function () {
			return store.state.tva_ids;
		},
	},
	created() {
		store.dispatch("getAllCustomers");
		store.dispatch("getAllTvaIds");
		store.dispatch("getAllCountries");
		store.dispatch("getAllTerms");
		this.refreshContact();
		this.getCommercialSociety(this.$props.society.id);
		this.getSocietyContracts(this.$props.society.id);
		this.getActivityDomain();
		this.getDomain();
		this.getCommercials();
		this.fetchLanguages();
		this.fetchCurrencies();
		this.getTopKeywords();
		if (this.$props.society.img_link) {
			//console.log("society.img_link", this.$props.society.img_link);
			this.getSocietyImage(this.$props.society);
		}
		this.tmp = JSON.parse(JSON.stringify(this.$props.society));
		if (!this.$props.allowEdit) {
			this.$vs.notify({
				title: "Attention",
				color: "warning",
				time: 5000,
				text: "Modification/ Ajout impossible. Passer par l'onglet client pour effectuer cette action",
			});
		}
		//console.log("SOXCIETU00", this.$props.society);
	},
	beforeMount() {
		store.dispatch("getAllCustomers");
		this.idQB = null;
		this.checkQB();
	},
	watch: {
		society: async function (data) {
			await this.getSocietyImage(data);
			await this.getAllRelatedUser(data.id);
			await this.getCommercialSociety(data.id);
			this.idQB = null;
		},
		"societyToModify.status": function (data) {
			if (data == true) {
				this.societyToModify.status = 1;
			}
			if (!data) {
				this.societyToModify.status = 0;
			}
		},
		"societyToModify.export_to_big_query": function (data) {
			if (data == true) {
				this.societyToModify.export_to_big_query = 1;
			}
			if (!data) {
				this.societyToModify.export_to_big_query = 0;
			}
		},

		relatedUser: function (data) {
			this.commercialContact = this.getCommercialContact(data);
			this.billingContact = this.getBillingContact(data);
		},
		popupActive: function () {
			this.isPopupActive = this.popupActive;
		},
		isPopupActive: function (data) {
			if (data == false) this.clearQueryParams();
			this.$emit("update:popupActive", this.isPopupActive);
		},
	},

	data() {
		return {
			displaySociety: this.$props.society,
			societyToModify: JSON.parse(JSON.stringify(this.$props.society)),
			relatedUser: null,
			colorQB: "orange",
			commercials: [],
			commercialSociety: null,
			commercialSocietyName: " ",
			commercialContact: null,
			billingContact: null,
			isImageModifyOn: true,
			idQB: null,
			image: null,
			languages: [],
			currencies: [],
			isPopupActive: this.popupActive,
			showValidationPopup: false,
			selectedContact: null,
			selectedContract: null,
			showContractPopup: false,
			societyContracts: [],
			societyImage: null,
			listAllDomains: [],
			listDomain: [],
			refreshEdit: 0,
			tagStyle: "z-index: 1 !important; overflow: auto;",
			tmp: [],
			originOptions: [
				{ text: "Agence", value: 1 },
				{ text: "Salon", value: 2 },
				{ text: "Prospection", value: 3 },
				{ text: "Appel Entrant", value: 4 },
				{ text: "Réseau", value: 5 },
				{ text: "Lead entrant", value: 6 },
				{ text: "Apporteur d'affaire", value: 7 },
				{ text: "Événements", value: 8 },
			],
			ecommerceOptions: [
				{ text: "E-commerce", value: 1 },
				{ text: "Vitrine", value: 0 },
			],

			// For popups
			showTopKeywordsPopup: false,
			topKeywords: [],
		};
	},

	methods: {
		refreshSocieties() {
			store.dispatch("getAllSocieties");
		},

		onClickTopKeywordsPopup() {
			try {
				this.showTopKeywordsPopup = true;
				let ComponentClass = Vue.extend(TopKeywordEditorPopup);
				let topKeywordPopup = new ComponentClass({
					propsData: {
						// initialKeywords: this.topKeywords,
						society: this.society || {}, // Évite undefined
						popupActive: this.showTopKeywordsPopup,
					},
				});

				topKeywordPopup.$mount();

				// Vérification de popupContainer avant l'ajout
				if (this.$refs.popupContainer) {
					this.$refs.popupContainer.appendChild(topKeywordPopup.$el);
				} else {
					console.error("popupContainer non trouvé");
				}

				topKeywordPopup.$on("close-popup", () => {
					this.showTopKeywordsPopup = false;
				});
			} catch (e) {
				console.error(e);
				this.$vs.notify({
					title: "Erreur",
					color: "danger",
					text: "Une erreur est survenue lors de l'ouverture du popup",
				});
			}
		},
		onClickCompetitors() {
			try {
				this.showTopKeywordsPopup = true;
				let ComponentClass = Vue.extend(SocietyCompetitorsPopup);
				let topKeywordPopup = new ComponentClass({
					propsData: {
						// initialKeywords: this.topKeywords,
						society: this.society || {}, // Évite undefined
						popupActive: this.showTopKeywordsPopup,
					},
				});

				topKeywordPopup.$mount();

				// Vérification de popupContainer avant l'ajout
				if (this.$refs.popupContainer) {
					this.$refs.popupContainer.appendChild(topKeywordPopup.$el);
				} else {
					console.error("popupContainer non trouvé");
				}

				topKeywordPopup.$on("close-popup", () => {
					this.showTopKeywordsPopup = false;
				});
			} catch (e) {
				console.error(e);
				this.$vs.notify({
					title: "Erreur",
					color: "danger",
					text: "Une erreur est survenue lors de l'ouverture du popup",
				});
			}
		},
		onClickBrands() {
			try {
				this.showTopKeywordsPopup = true;
				let ComponentClass = Vue.extend(SocietyBrandsPopup);
				let topKeywordPopup = new ComponentClass({
					propsData: {
						// initialKeywords: this.topKeywords,
						society: this.society || {}, // Évite undefined
						popupActive: this.showTopKeywordsPopup,
					},
				});

				topKeywordPopup.$mount();

				// Vérification de popupContainer avant l'ajout
				if (this.$refs.popupContainer) {
					this.$refs.popupContainer.appendChild(topKeywordPopup.$el);
				} else {
					console.error("popupContainer non trouvé");
				}

				topKeywordPopup.$on("close-popup", () => {
					this.showTopKeywordsPopup = false;
				});
			} catch (e) {
				console.error(e);
				this.$vs.notify({
					title: "Erreur",
					color: "danger",
					text: "Une erreur est survenue lors de l'ouverture du popup",
				});
			}
		},
		getTopKeywords() {
			this.$http
				.get(this.apiUrl + "society/getTopKeywords/" + this.society.id)
				.then((res) => {
					this.topKeywords = res.data;
				})
				.catch((err) => console.log(err));
		},
		onClickUpdate() {
			// some variable are not avilable in the society object
			if (!this.$props.allowEdit) {
				this.$vs.notify({
					title: "Echec",
					color: "warning",
					text: "Passer par l'onglet client.",
				});
			} else {
				this.societyToModify.edit = true;
				this.refreshEdit++;
			}
		},
		/** Get language name from id */
		getLanguageName(id) {
			let thislang = this.languages.find((lang) => lang.id == id);
			return thislang ? thislang.name : " ";
		},
		/** Get Currency name from id */
		getCurrenciesName(id) {
			let thislang = this.currencies.find((lang) => lang.id == id);
			return thislang ? thislang.name : " ";
		},
		/**
		 * Fetch the list of languages
		 */
		async fetchLanguages() {
			this.languages = await Society.getLanguages();
		},
		/**
		 * Fetch the list of currencies
		 */
		async fetchCurrencies() {
			this.currencies = await Product.getCurrencies();
		},
		addImagePreview(e) {
			this.image = URL.createObjectURL(e.target.files[0]);
			this.isImageModifyOn = true;
		},
		//Check if this society exists in societies_quickbooks_customers
		async checkQB() {
			await this.$http
				.get(this.apiUrl + "qb/select/" + this.society.id)
				.then(async (res) => {
					if (res && res.data && res.data.length > 0) {
						this.colorQB = "green";
						this.idQB = res.data[0].pennylane_customer_id;
					} else this.colorQB = "red";
				});
		},
		modifyContract(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 0,
					updateEntityForm: "contracts",
				},
			});
		},
		modifyMissions(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 1,
					updateEntityForm: "contracts",
				},
			});
		},
		modifyPurchase(purchase) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: { purchaseId: purchase.id, updateEntityForm: "purchases" },
			});
		},
		renewPurchase(purchaseId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "new_entity",
				params: { purchaseId: purchaseId, newEntityForm: "renewpurchase" },
			});
		},
		displayContractPopup(contract) {
			//console.log("displayContractPopup", contract);
			this.selectedContract = contract;
			this.$emit("contract-info-popup", contract);
		},

		getActivityDomain() {
			this.$http
				.get(this.apiUrl + "tags/society/" + this.society.id)
				.then((res) => {
					let tmp = res.data;
					for (let tag of tmp) {
						tag["name"] = tag.tag_name;
						tag["slug"] = tag.tag_name;
						delete tag.tag_name;
					}
					this.listDomain = tmp;
					this.society.activity_domain = tmp || [];
					this.societyToModify.activity_domain = tmp || [];
				})
				.catch((err) => console.log(err));
		},

		getCommercials() {
			this.$http
				.get(this.apiUrl + "users/all/rankwell")
				.then((fetchedRankwell) => {
					this.commercials = this.sortABC(
						fetchedRankwell.data.filter((collaborator) =>
							[4, 6, 9].includes(collaborator.type)
						),
						"firstname"
					);
				})
				.catch((err) => {
					console.error(err);
				});
		},

		getDomain() {
			this.$http
				.get(this.apiUrl + "tags/all")
				.then((res) => {
					let tmp = res.data;
					for (let tag of tmp) {
						tag["name"] = tag.tag_name;
						tag["slug"] = tag.tag_name;
						delete tag.tag_name;
					}
					this.listAllDomains = tmp;
				})
				.catch((err) => console.log(err));
		},

		async getSocietyContracts(societyId) {
			await this.$http
				.get("contract/getcs/" + societyId)
				.then(async (res) => {
					if (this.activeUser.userRole == "171") {
						let list = [];
						for (let c of res.data) {
							await this.$http.get("users/all/amcfs/" + c.id).then((res) => {
								let foundUser = res.data.find(
									(ac) => ac.id == this.activeUser.id
								);
								if (foundUser) list.push(c);
							});
						}
						console.log("societyContract", list);
						this.societyContracts = list;
					} else this.societyContracts = res.data;
					// removing contract which has been deleted or is not shown
					this.societyContracts = this.societyContracts.filter(
						(contract) => contract.status != 2
					);
					//console.log("societyContract", this.societyContracts);
				})
				.catch((err) => console.error(err));
		},

		getAllRelatedUser(societyId) {
			this.$http
				.get("users/getuserforsociety/" + societyId)
				.then((res) => {
					this.relatedUser = res.data;
				})
				.catch((err) => console.error(err));
		},
		/**
		 * Fetch the commercial in charge of the society
		 */
		getCommercialSociety(societyId) {
			Collaborator.getCommercialSociety(societyId, (err, res) => {
				if (err) {
					//console.log(err);
				}
				if (res) {
					//console.log("res", res);
					this.commercialSociety = res;
					this.commercialSocietyName =
						this.commercialSociety.firstname +
						" " +
						this.commercialSociety.lastname;
				}
			});
		},

		getFonction(fonction) {
			if (fonction !== "null") return fonction;
			else return "";
		},

		/**
		 * Open form to modify the contact passed in argument
		 * @param {Number} contactId - Contact ID to modify
		 */
		modifySociety(societyId) {
			let updateEntityForm = "society";
			sessionStorage.setItem("popupOriginSocietyId", societyId);
			var popupElements = document.querySelectorAll(".con-vs-popup");
			popupElements.forEach(function (element) {
				element.parentNode.removeChild(element);
			});
			//console.log(this);
			this.$props.router.push({
				name: "update_entity",
				params: { societyId, updateEntityForm },
			});
			this.isPopupActive = false;
			//console.log("modifySociety");
		},

		/**
		 * Open form to modify the contact passed in argument
		 * @param {Number} contactId - Contact ID to modify
		 */
		modifyContact(contactId) {
			//console.log(contactId);
			let updateEntityForm = "contact";
			let societyId = this.societyId;
			sessionStorage.setItem("popupOriginSocietyId", societyId);
			var popupElements = document.querySelectorAll(".con-vs-popup");
			popupElements.forEach(function (element) {
				element.parentNode.removeChild(element);
			});
			this.$props.router.push({
				name: "update_entity",
				params: { contactId, societyId, updateEntityForm },
			});
			this.isPopupActive = false;
			//console.log("modifyContact");
		},

		/**
		 * Open form to create new contact for the society passed in argument
		 * @param {Number} societyId - Society ID to add contact to
		 */
		newContact(societyId) {
			//console.log(societyId);
			let newEntityForm = "contact";
			sessionStorage.setItem("popupOriginSocietyId", societyId);
			var popupElements = document.querySelectorAll(".con-vs-popup");
			popupElements.forEach(function (element) {
				element.parentNode.removeChild(element);
			});
			this.$props.router.push({
				name: "new_entity",
				params: { societyId, newEntityForm },
			});
			//console.log("popupActive 1:");
			//console.log(this.isPopupActive);
			this.isPopupActive = false;
			//console.log("popupActive 1:");
			//console.log(this.isPopupActive);
			//console.log("newContact");
		},

		/**
		 * Delete the contact passed in argument
		 * @param {Number} contactId - Contact ID to delete
		 */
		deleteContact(contactId) {
			this.$http
				.delete(
					this.apiUrl +
						"usersSocieties/delete/u/" +
						contactId +
						"/s/" +
						this.societyId
				)
				.then(() => {
					// Send a success notification to the user
					this.$vs.notify({
						title: "Succès",
						text: "Contact effacé avec succès.",
					});
					// Refresh List
					this.refreshContact();
				})
				.catch((err) => {
					//console.log(err);
					this.$vs.notify({
						title: "Erreur",
						text: "Le contact n'a pas été effacé.",
					});
				});
		},

		acceptDeletion() {
			this.deleteContact(this.selectedContact);
			this.showValidationPopup = false;
		},

		declineDeletion() {
			this.selectedContact = null;
			this.showValidationPopup = false;
		},

		displayValidationPopup(contactId) {
			this.selectedContact = contactId;
			this.showValidationPopup = true;
		},

		refreshContact() {
			//console.log("Refreshing Contacts");
			this.getAllRelatedUser(this.societyId);
		},

		/**
		 * Fetch image if society.image is true else return false
		 * @param {Society} society - The society from which image is requested
		 */
		getSocietyImage(society) {
			if (society.img_link) {
				this.$http
					.get(this.apiUrl + "society/getImg/" + society.id)
					.then((image) => {
						this.societyImage = image.data;
					})
					.catch((err) => {
						//console.log(err);
					});
			} else {
				this.societyImage = society.image;
			}
		},

		onTagAdded(tag) {
			if (this.societyToModify.activity_domain.indexOf(tag) < 0) {
				this.societyToModify.activity_domain.push(tag);
			}
		},

		onTagRemoved(tag) {
			this.societyToModify.activity_domain.splice(
				this.societyToModify.activity_domain.indexOf(tag),
				1
			);
		},

		validateTVARequired() {
			let country = this.countries.find(
				(c) => c.id == this.societyToModify.country_id
			);
			if (country.tva_required == 1 && !this.societyToModify.tva) {
				this.$vs.notify({
					title: "Echec",
					text: "Le numéro de TVA est obligatoire pour ce pays.",
				});
				return false;
			} else {
				this.societyToModify.country = country.fr_fr_name;
				return true;
			}
		},

		validateWebsite() {
			if (this.societyToModify.website) {
				let regex = new RegExp(/^https?:\/\/(?!.*:\/\/)\S+/);
				if (regex.test(this.societyToModify.website)) return true;
				else {
					this.$vs.notify({
						title: "Echec",
						text: "Site web saisi n'est pas une URL valide (http(s)://domain.com).",
					});
					return false;
				}
			} else return true;
		},
		/**
		 * Validate that the Search Console URL starts with https://www.
		 * @returns {boolean} True if URL is valid or empty, false otherwise
		 */
		validateGscUrl() {
			if (!this.societyToModify.gsc_url) {
				return true; // Empty is acceptable
			}

			const regex = new RegExp(/^https:\/\/www\./);
			if (regex.test(this.societyToModify.gsc_url)) {
				return true;
			} else {
				// If URL doesn't start with https://www. but contains some value
				if (this.societyToModify.gsc_url.trim()) {
					// Try to fix common issues like missing https:// or www.
					let fixedUrl = this.societyToModify.gsc_url;

					// Make sure it starts with https://
					if (!fixedUrl.startsWith("https://")) {
						fixedUrl = fixedUrl.startsWith("http://")
							? "https://" + fixedUrl.substring(7)
							: "https://" + fixedUrl;
					}

					// Make sure it has www. after https://
					if (!fixedUrl.startsWith("https://www.")) {
						fixedUrl = "https://www." + fixedUrl.substring(8);
					}

					// Update with fixed URL
					this.societyToModify.gsc_url = fixedUrl;

					this.$vs.notify({
						title: "Information",
						text: "L'URL a été formatée au format requis pour Search Console (https://www.)",
						color: "primary",
					});

					return true;
				}

				// Show error and reset
				this.$vs.notify({
					title: "Erreur",
					text: "L'URL de Search Console doit commencer par 'https://www.'",
					color: "danger",
				});

				return false;
			}
		},

		updateSociety(updateImage = false) {
			if (updateImage) {
				this.$refs.cropper
					.getCroppedCanvas({ width: 264, height: 150 })
					.toBlob((blob) => {
						//console.log("cropping", blob);
						let formData = new FormData();
						formData.append("image", blob, "society.png");
						this.$props.society.img_link = formData;
						//console.log("Formdata: ", formData);
						this.$http
							.post(
								this.apiUrl + "society/updateImage/" + this.societyToModify.id,
								formData,
								{
									headers: {
										accept: "application/json",
										"Accept-Language": "en-US,en;q=0.8",
										"Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
									},
								}
							)
							.then(() => {
								// this.$props.society.img_link = this.image;
								this.$vs.notify({
									title: "Succès",
									text: "Image du client modifée avec succès.",
								});
								this.isImageModifyOn = false;
								this.societyImage = this.image;
							})
							.catch((err) => {
								this.$vs.notify({
									title: "Echec",
									text: "L'image du client n'a pas été modifée.",
								});
								//console.log(err);
							});
					});
			} else {
				if (this.validateTVARequired()) {
					if (this.validateWebsite() && this.validateGscUrl()) {
						if (this.societyToModify.siret)
							this.societyToModify.siret = this.transformSiretDbFormat(
								this.societyToModify.siret
							);
						this.societyToModify.creation_timestamp =
							this.societyToModify.creation_timestamp.replace(/T|Z/g, " ");
						this.societyToModify.last_update_timestamp =
							new Date().toISOString().substr(0, 10) + " 02:00:00";

						let tmp = JSON.parse(JSON.stringify(this.societyToModify));
						delete tmp.edit;
						let editSociety = new Society(tmp);
						editSociety.activity_domain = this.societyToModify.activity_domain;
						editSociety.update(this.societyToModify.id, (err, res) => {
							if (err) {
								//console.log(err);
								// Send a failure notification to the user
								this.$vs.notify({
									title: "Echec",
									text: "Une erreur est survenue.",
								});
							}
							if (res) {
								//If there if something in the image input field, Update Image
								if (this.image) {
									// this.addImageToPost()
									this.$refs.cropper
										.getCroppedCanvas({ width: 264, height: 150 })
										.toBlob((blob) => {
											//console.log("cropping", blob);
											let formData = new FormData();
											formData.append("image", blob, "society.png");
											this.$props.society.img_link = formData;
											//console.log("Formdata: ", formData);
											this.$http
												.post(
													this.apiUrl +
														"society/updateImage/" +
														this.societyToModify.id,
													formData,
													{
														headers: {
															accept: "application/json",
															"Accept-Language": "en-US,en;q=0.8",
															"Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
														},
													}
												)
												.then(() => {
													// this.$props.society.img_link = this.image;
													this.$vs.notify({
														title: "Succès",
														text: "Client modifé avec succès.",
													});
													this.isImageModifyOn = false;
													this.societyImage = this.image;

													this.societyToModify.edit = false;
													this.society = this.societyToModify;
												})
												.catch((err) => {
													this.$vs.notify({
														title: "Echec",
														text: "L'image du client n'a pas été modifée.",
													});
													//console.log(err);
												});
										});
								} else {
									this.$vs.notify({
										title: "Succès",
										text: "Client modifié avec succès.",
									});
									this.societyToModify.edit = false;
									this.society = this.societyToModify;
								}
								this.refreshSocieties();
								this.refreshEdit++;
							}
						});
					}
				}
			}
		},

		updateSocietyQuickbooksCustomer() {
			if (!this.idQB || this.idQB == 0) {
				this.$http
					.post(this.apiUrl + "qb/sqbc/delete", { society_id: this.society.id })
					.then((res) => {
						if (res) {
							this.$vs.notify({
								title: "Succès",
								text: "Customer Pennylane ID supprimé avec succès.",
							});
						}
					});
			} else {
				this.$http
					.get(this.apiUrl + "qb/select/" + this.society.id)
					.then((res) => {
						if (res && res.data && res.data.length > 0) {
							this.$http
								.post(this.apiUrl + "qb/sqbc/update", {
									society_id: this.society.id,
									quickbooks_id: this.idQB,
								})
								.then((result) => {
									if (result) {
										this.$vs.notify({
											title: "Succès",
											text: "Customer Pennylane ID modifié avec succès.",
										});
									}
								});
						} else {
							this.$http
								.post(this.apiUrl + "qb/sqbc/add", {
									society_id: this.society.id,
									quickbooks_id: this.idQB,
								})
								.then((result) => {
									if (result) {
										this.$vs.notify({
											title: "Succès",
											text: "Customer Pennylane ID ajouté avec succès.",
										});
									}
								});
						}
					});
			}
		},
		clearQueryParams() {
			try {
				if (this.$props.router.query.society_id) {
					this.$props.router.push({
						path: this.$props.router.path,
						query: { ...this.$props.router.query, society_id: undefined },
					});
				}
			} catch (e) {
				console.log("Error in clearQueryParams", e);
			}
		},
	},
};
</script>

<style scoped>
.hvr-underline-out {
	color: black;
}
.hvr-underline:hover {
	color: aqua;
	text-decoration: underline;
	cursor: pointer;
}

.center {
	justify-content: center;
}

.right-elem {
	justify-content: flex-end;
}

.bg-color {
	background: #35e9fd !important;
}

.t-border {
	border-top: 1px solid grey;
}

.l-border {
	border-left: 1px solid grey;
}

.title {
	font-weight: 600;
	font-size: 2em;
}

.f-color {
	color: black;
}

.center-align {
	display: flex;
	align-items: center;
}

.no-width-limit {
	width: unset;
}
</style>
